import type { TFunction } from 'i18next';
import type { RoleCopy } from './types';

export function applicationProcess(copy: RoleCopy, t: TFunction): string[] {
  return copy.applicationProcess ?? ['submit', 'screening', 'interview', 'team', 'offer'].map(step => t(`hiring.processSteps.${step}`, { lng: 'en' }));
}
